import {
  CANDIDATE_CERTIFICATION_UPDATE_REQUEST,
  CANDIDATE_CERTIFICATION_UPDATE_SUCCESS,
  CANDIDATE_CERTIFICATION_UPDATE_FAIL,
} from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

const token = localStorage.getItem('token');



export const CandidateCertificationAction = (data, navigate) => {
  return function (dispatch) {
    dispatch({
      type: CANDIDATE_CERTIFICATION_UPDATE_REQUEST,
      payload: true,
    });

    return new Promise((resolve, reject) => {
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/add_certificate`,
        method: "POST",
        data: data,
        headers: {
          "content-type": "multipart/form-data",
          "Authorization": "Bearer " + token
        },
      };

      axios(OPTION)
        .then((res) => {
          dispatch(updateDashboardContentPre(res.data, navigate));
          resolve(res.data);
        })
        .catch((error) => {
          console.log('ERROR--->', error?.response.data.status.message)
          toast.error(error?.response.data.status.message);
          reject(error);
          dispatch({
            type: CANDIDATE_CERTIFICATION_UPDATE_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    })


  };
};

export const updateDashboardContentPre = (data, navigate) => {
  toast.success("Updated Successfully!");

  // setTimeout(() => {
  //     navigate('/candidate_dashboard')
  // }, 1400);
  return {
    type: CANDIDATE_CERTIFICATION_UPDATE_SUCCESS,
    result: data,
    payload: false,
    msg: "SUCCESS",
  };
};

export const AddExperienceAction = (data) => {
  return function (dispatch) {
    dispatch({
      type: CANDIDATE_CERTIFICATION_UPDATE_REQUEST,
      payload: true,
    });

    return new Promise((resolve, reject) => {
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/add_work_experience`,
        method: "POST",
        data: data,
      };

      axios(OPTION)
        .then((res) => {
          resolve(res.data);
          return {
            type: CANDIDATE_CERTIFICATION_UPDATE_SUCCESS,
            result: data,
            payload: false,
            msg: "SUCCESS",
          };
        })
        .catch((error) => {
          console.log('ERROR--->', error?.response.data.status.message)
          toast.error(error?.response.data.status.message);
          reject(error);
          dispatch({
            type: CANDIDATE_CERTIFICATION_UPDATE_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });

        });
    })


  };
}